// @flow

import React from 'react';
import styled from 'styled-components';
import NewsOverviewItem from './atoms';
import type { Theme } from '../../../types';
import { type ACFImage } from '../../../types/acf';

const Icon = styled<any, Theme>('i')`
  margin: 0 1rem 0 0;
  font-size: 1.7rem;
  color: ${props => props.theme.news.overviewTitleColor};
  line-height: 0;
`;

const OverviewTitle = styled<any, Theme>('h3')`
  color: ${props => props.theme.news.overviewTitleColor};
  align-self: center;
`;

const Header = styled<any, Theme>('div')`
  display: flex;
`;

const Container = styled<any, Theme>('div')`
  padding: 2rem 0 0 0;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  height: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid ${props => props.theme.divider.color};
`;

type Props = {
  items: Array<{|
    title: string,
    date: string,
    link: string,
    image: ACFImage,
    intro: string,
  |}>,
  latestArticlesLabel: string,
};

const NewsOverview = ({ items, latestArticlesLabel }: Props) => (
  <Container>
    <Header>
      <Icon className="icon-clock" />
      {' '}
      <OverviewTitle>{latestArticlesLabel}</OverviewTitle>
    </Header>
    {items.slice(0, 5).map(({ title, date, link }, index) => (
      <NewsOverviewItem
        key={`overview-${index}`} // eslint-disable-line react/no-array-index-key
        title={title}
        date={date}
        link={link}
      />
    ))}
  </Container>
);

export default NewsOverview;
